import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Lables from '../../components/translations/translation.json'
import { Button , Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions } from '@mui/material';
//css file
import './deleteFileModal.css';


function DeleteFileModal(props) {

  console.log("props lang in DeleteFileModal",props.langProp);
    const [open ] =  useState(true);
    const [close] =  useState(true);

    const handleClose = () => {
        props.callbackImageDeleteClose(false);
    }

    const handleDelete = () => {
        props.callbackImageDelete(false);
    }

  return (
   <>
      <Dialog aria-labelledby= "customized-dialog-title" className='dialog-modal' open={open}> 
      <DialogTitle className="dialogTitle-deleteFile" sx={{ m: 0, p: 2 }}>           
      {Lables[props.langProp].CONFORMATION_MODAL}                     
          { close ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: '#000',
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}                             
      </DialogTitle>               
      <DialogContent dividers  className="dialog-content">                    
          <DialogContentText className="dialog-content-text"> 
          <span className="textBody-deleteFile"> {Lables[props.langProp].DELETE_IMAGE_CONFIRMATION}</span>   
          </DialogContentText>                           
      </DialogContent>
      <DialogActions>                
      <Button variant="contained" className="button-ok-deleteFile" onClick={handleDelete} >{Lables[props.langProp].OK} </Button>
      <Button variant="contained" onClick={handleClose} className="button-close-deleteFile">{Lables[props.langProp].CANCEL}</Button>
      </DialogActions>
    </Dialog>
  </>
  );
}

DeleteFileModal.propTypes = {
  langProp: PropTypes.string,
  callbackImageDeleteClose: PropTypes.func,
  callbackImageDelete: PropTypes.func,
};

export default DeleteFileModal;
